/**
 * groups constants
 */
export const GROUP_CREATE_REQUESTED = 'GROUP_CREATE_REQUESTED';
export const GROUP_CREATE_SUCCEEDED = 'GROUP_CREATE_SUCCEEDED';
export const GROUP_CREATE_FAILED = 'GROUP_CREATE_FAILED';

export const GROUP_UPDATE_REQUESTED = 'GROUP_UPDATE_REQUESTED';
export const GROUP_UPDATE_SUCCEEDED = 'GROUP_UPDATE_SUCCEEDED';
export const GROUP_UPDATE_FAILED = 'GROUP_UPDATE_FAILED';

export const GROUP_DELETE_REQUESTED = 'GROUP_DELETE_REQUESTED';
export const GROUP_DELETE_SUCCEEDED = 'GROUP_DELETE_SUCCEEDED';
export const GROUP_DELETE_FAILED = 'GROUP_DELETE_FAILED';
